import React from 'react';

import type { Participants } from '@swf/sports/types/event';
import type { Orientation } from '@swf/sports/types/liveData';

import Score, { Team } from '../../../Score/Score';

import styles from './FootballUnavailable.scss';

interface Props {
  participants: Participants;
  isLoading?: boolean;
  orientation?: Orientation;
}

const FootballUnavailable: React.FC<Props> = ({
  participants,
  isLoading,
  orientation = 'vertical'
}) => {
  const [home, away] = participants;

  return (
    <div data-testid="football-scoreboard-unavailable">
      {orientation === 'horizontal' ? (
        <div className={styles.team}>
          <span className={styles.name}>{home}</span>
          <span className={styles.score}>
            <Score team={Team.HOME} isLoading={isLoading} orientation="horizontal" />
            {' - '}
            <Score team={Team.AWAY} isLoading={isLoading} orientation="horizontal" />
          </span>
          <span className={styles.name}>{away}</span>
        </div>
      ) : (
        <>
          <div className={styles.team}>
            <Score team={Team.HOME} isLoading={isLoading} />
            <span className={styles.name}>{home}</span>
          </div>
          <div className={styles.team}>
            <Score team={Team.AWAY} isLoading={isLoading} />
            <span className={styles.name}>{away}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default FootballUnavailable;
